// Add js class to body for CSS targeting
document.body.classList.add('js');

// Add js class to body for CSS targeting
document.body.classList.add('js');

// Global variable to store the Ajaxinate instance
let ajaxinateInstance = null;
let lastLoadedPage = 1;

// Initialize Ajaxinate for infinite scrolling
function initInfiniteScroll() {
  // Initialize infinite scroll if products are present
  const productGrid = document.getElementById('product-grid');
  const pagination = document.querySelector('.AjaxinatePagination');
  
  if (productGrid && pagination) {
    // If we already have an instance, clean up event listeners first
    if (ajaxinateInstance) {
      ajaxinateInstance.removeScrollListener();
    }
    
    // Get the current page number
    let currentPage = 1;
    try {
      const url = new URL(window.location.href);
      const pageParam = url.searchParams.get('page');
      if (pageParam) {
        currentPage = parseInt(pageParam, 10);
      }
      lastLoadedPage = currentPage;
    } catch (e) {
      console.warn('Could not parse URL for page number:', e);
    }
    
    console.log('Initializing infinite scroll on page:', currentPage);
    
    // Create new instance
    ajaxinateInstance = new Ajaxinate({
      container: '.AjaxinateLoop',
      pagination: '.AjaxinatePagination',
      method: 'scroll',
      offset: 800,
      loadingText: 'Loading more products...',
      callback: function(pageLoaded) {
        console.log('Loaded page:', pageLoaded || 'unknown');
        
        // Track the last loaded page to prevent duplicates
        if (pageLoaded) {
          lastLoadedPage = pageLoaded;
        }
        
        // Reinitialize quick-add buttons if they exist
        if (window.quickAddInit) {
          window.quickAddInit();
        }
        
        // Reinitialize product cards with hover effects
        initializeProductCards();
        
        // Handle featured collection blocks
        handleFeaturedBlocks();
        
        // Dispatch a custom event that other scripts can listen for
        const event = new CustomEvent('ajaxinateLoaded', { 
          detail: { page: pageLoaded || lastLoadedPage + 1 } 
        });
        document.dispatchEvent(event);
      }
    });
    
    return ajaxinateInstance;
  }
  
  return null;
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  initInfiniteScroll();
});

// Also listen for the custom event that might be dispatched when filter results are loaded
document.addEventListener('collection:updated', function() {
  setTimeout(initInfiniteScroll, 300);
});

// Initialize product cards with hover effects
function initializeProductCards() {
  const productCards = document.querySelectorAll('.card-product');
  if (productCards.length > 0) {
    productCards.forEach(card => {
      // Skip already initialized cards
      if (card.hasAttribute('data-initialized')) return;
      
      card.addEventListener('mouseenter', function() {
        this.classList.add('card-product--hovered');
      });
      
      card.addEventListener('mouseleave', function() {
        this.classList.remove('card-product--hovered');
      });
      
      card.setAttribute('data-initialized', 'true');
    });
  }
}

// Handle featured collection blocks
function handleFeaturedBlocks() {
  // Make sure featured collection blocks are properly sized and styled
  const featuredBlocks = document.querySelectorAll('.featured-collection-block');
  if (featuredBlocks.length > 0) {
    // Additional initialization if needed for featured blocks
    // This ensures any JavaScript behavior needed for featured blocks works
    
    // For example, if you have any click handlers or special behavior
    featuredBlocks.forEach(block => {
      // Skip already initialized blocks
      if (block.hasAttribute('data-initialized')) return;
      
      // Any additional initialization code here
      
      block.setAttribute('data-initialized', 'true');
    });
  }
}

// Run initializers on page load
document.addEventListener('DOMContentLoaded', function() {
  initializeProductCards();
  handleFeaturedBlocks();
});
